import {
  useNavigate,
  useLocation,
  useSearchParams,
  useParams,
} from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useMemo, useState } from "react";
import {
  useLazyGetRoleByIdQuery,
  AccessRoleData,
} from "../../service/accessRole";
import { showError } from "../../constants/toasts";
import Loader from "../../constants/Loader";
import moment from "moment";

const RoleDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [getRoleById, { isLoading }] = useLazyGetRoleByIdQuery();
  const [role, setRole] = useState<AccessRoleData | null>(null);

  // const roleId = useMemo(() => {
  //   return searchParams.get("id") || (role as any)?._id || "";
  // }, [role, searchParams]);

  useEffect(() => {
    const load = async () => {
      if (id) {
        try {
          const res = await getRoleById({ id }).unwrap();
          const ok =
            res?.code === 200 || res?.statusCode === 200 || res?.status === 200;
          if (ok) {
            setRole(res?.data || null);
          } else {
            showError(res?.message || "Failed to fetch role details");
            navigate("/manage-subadmin/roles");
          }
        } catch (e: any) {
          showError(e?.data?.message || "Failed to fetch role details");
          navigate("/manage-subadmin/roles");
        }
      }
    };
    load();
  }, [getRoleById, navigate]);

  return (
    <>
      <div className="main_title">
        <h1>Role Detail</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-subadmin")}>
            Manage Sub-Admin
          </button>{" "}
          -{" "}
          <button onClick={() => navigate("/manage-subadmin/roles")}>
            Manage Roles
          </button>{" "}
          - Role Detail
        </p>
      </div>
      <Loader isLoad={isLoading} />

      <div className="cards view_page">
        <div className="gap_p">
          <div className="w_33">
            <h6>Role Name</h6>
            <p>{role?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Created Date</h6>
            <p>
              {role?.createdAt ? moment(role.createdAt).format("lll") : "-"}
            </p>
          </div>
        </div>

        <TableContainer className="table_container mt_20">
          <Table>
            <TableHead>
              <TableRow hover>
                <TableCell>Module Name</TableCell>
                <TableCell align="center">View</TableCell>
                <TableCell align="center">Add/Edit</TableCell>
                {/* <TableCell align="center">Edit</TableCell> */}
                <TableCell align="center">Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(role?.permissions || []).map((p) => (
                <TableRow hover key={p._id}>
                  <TableCell>{p.label}</TableCell>
                  <TableCell align="center">
                    {p.isView ? (
                      <DoneIcon className="c_success" />
                    ) : (
                      <CloseIcon className="c_danger" />
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {p.isAdd ? (
                      <DoneIcon className="c_success" />
                    ) : (
                      <CloseIcon className="c_danger" />
                    )}
                  </TableCell>
                  {/* <TableCell align="center">
                    {p.isEdit ? (
                      <DoneIcon className="c_success" />
                    ) : (
                      <CloseIcon className="c_danger" />
                    )}
                  </TableCell> */}
                  <TableCell align="center">
                    {p.isDelete ? (
                      <DoneIcon className="c_success" />
                    ) : (
                      <CloseIcon className="c_danger" />
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default RoleDetail;
